import React from 'react'
import PropTypes from 'prop-types'

import ClubFeedPopupFooter from './club_feed_popup_footer'
import { clubFeedChannelsArmed } from '../club_feed_channels'

const t = (key) => (window.I18n ? window.I18n.t(key) : '')

const ClubFeedNotificationCheckbox = ({ channels, settingsUrl, learnMoreUrl, checked, onChange, inputId }) => {
  if (!clubFeedChannelsArmed(channels)) {
    return null
  }

  return (
    <div className="club_feed_notifications_checkbox text-center add-margin-top-15">
      <div className="checkbox btsp_checkbox checkbox-primary skip_notifications_checkbox">
        <input
          id={ inputId }
          type="checkbox"
          name="skip_notifications"
          value="1"
          checked={ checked }
          onChange={ (event) => onChange(event.target.checked) }
        />
        <label className="skip_notifications_label" htmlFor={ inputId }>
          <span className="clickable">{ t('club_feed.checkbox.skip_notifications') }</span>
        </label>
      </div>
      <ClubFeedPopupFooter settingsUrl={ settingsUrl } learnMoreUrl={ learnMoreUrl } compact />
    </div>
  )
}

ClubFeedNotificationCheckbox.propTypes = {
  channels: PropTypes.shape({
    feed: PropTypes.bool,
    push: PropTypes.bool,
    push_notification: PropTypes.bool,
  }),
  settingsUrl: PropTypes.string,
  learnMoreUrl: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  inputId: PropTypes.string,
}

ClubFeedNotificationCheckbox.defaultProps = {
  checked: false,
  inputId: 'club_feed_skip_notifications',
}

export default ClubFeedNotificationCheckbox
